import { Skeleton } from '@wellesley/ui'

type UsersPreviewSkeletonProps = {
  size?: number
  count?: number
}

const GAP = 4

const UsersPreviewSkeleton = ({
  count = 5,
  size = 24,
}: UsersPreviewSkeletonProps) => (
  <div
    data-testid="users-preview-skeleton"
    className="relative flex flex-col"
    style={{
      width: count * (size - GAP) + GAP,
      height: size,
    }}
  >
    {Array.from({ length: count }).map((_, index: number) => (
      <Skeleton
        style={{
          left: index * (size - GAP),
          width: size,
          height: size,
        }}
        className="absolute top-0 rounded-full"
        key={index}
      />
    ))}
  </div>
)

export default UsersPreviewSkeleton
